export default "__VITE_ASSET__SyiRIjSj__"